// Electric-vehicle handling.
//
//   EV = car_fuel 3. There is no time-gated discount: the campaign-based 80%
//   annual-tax reduction (9 Nov 2022 - 10 Nov 2025) was removed because
//   correctly pro-rating it across years of back tax (only the very first
//   tax year after registration could ever qualify) was judged not worth the
//   complexity for how rarely it would even apply. Electric vehicles simply
//   use whichever rate baseTax.js assigns their type for being electric
//   (e.g. CT1 uses the CT2 table, CT4 is a flat 50 baht instead of 100) —
//   permanently, not for a limited window.
//
// 'CT11' used to be the legacy code for "รย.1 + electric", normalised here to
// CT1+fuel=3 while the one-time car_type database migration was still
// pending. That migration is complete, and the new registry reassigns the
// string 'CT11' to a different, unrelated category (รย.11 "รถยนต์บริการให้
// เช่า" - a rental car) - so a car_type of 'CT11' from here on is a genuine
// new category, not a legacy EV marker, and must NOT be rewritten to CT1.

export function isElectric(carFuel) {
  return Number(carFuel) === 3;
}

export function normalizeVehicle(carType, carFuel) {
  return { carType: carType, carFuel: carFuel };
}
